module.exports = __webpack_public_path__ + "img/Clicktoclaim.4806e0c1.png";